import {
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { allEntVistasAction } from '../EntVistasAction';

const SelectFieldEntVistasComponent = ({
  onChange,
  data,
  value,
  selects = [],
}) => {
  const dispatch = Redux.useDispatch();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const entVistasStore = Redux.useSelector((state) => state.entVistas);

  const [items, setItems] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    const fetchData = async () => {
      if (!data && entVistasStore.all.length === 0) {
        setLoading(true);
        await allEntVistasAction(
          { dispatch },
          {
            idEntidad: entidadesStore.activo.id,
          },
        );
        setItems(entVistasStore.all);
      }
      setLoading(false);
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const _handlerSelects = () => {
    let items = [];
    if (selects.length > 0) {
      entVistasStore.all.forEach((se) => {
        const existSeletc = selects.some((item) => item.id === se.id);
        if (!existSeletc) items.push(se);
      });
      setItems(items);
    } else {
      if (data) {
        setItems(data);
      } else {
        setItems(entVistasStore.all);
      }
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(() => _handlerSelects(), [selects]);

  const select = (
    <FormControl fullWidth size="small">
      <InputLabel id={`label_${CONST.vista.name}`}>
        {CONST.vista.label}
      </InputLabel>
      <Select
        id={CONST.vista.name}
        value={value}
        labelId={`label_${CONST.vista.name}`}
        label={CONST.vista.label}
        onChange={(e) => onChange(e.target.value)}
      >
        {items.map((el, index) => {
          return (
            <MenuItem key={`vista-${index}`} value={el.id}>
              {el.vista.nombre}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );

  return loading ? <CircularProgress color="inherit" size={20} /> : select;
};

export default SelectFieldEntVistasComponent;
